import React, { Component } from 'react';
import utilFunction from '../../containers/function'
import strings from '../locales/';
import BarChart from '../common/graphs/crossfilterGraphs/barChart';

const DriversRiskDistributionGraph = (props) => (
  <div id="drivers-risk-distribution-graph" className="dc-chart-parent">
    <BarChart 
      id={"drivers-risk-distribution-graph-component"} 
      additionalCrossfilterData={null}
      crossfilerData={utilFunction.generateCrossfilter(props.data)}
      stack={false} 
      dimension={{
        formatFunction:[],
        name:"label",
        originalName:"label",
        reduceFunction:{"type":"DISCRETE_GROUP","typeof":"STRING","parameters":{"categoriesParser":[],"categories":[
          [{"value":"0-10","operator":"=="}],
          [{"value":"10-20","operator":"=="}],
          [{"value":"20-30","operator":"=="}],
          [{"value":"30-40","operator":"=="}],
          [{"value":"40-50","operator":"=="}],
          [{"value":"50-60","operator":"=="}],
          [{"value":"60-70","operator":"=="}],
          [{"value":"70-80","operator":"=="}],
          [{"value":"80-90","operator":"=="}],
          [{"value":"90-100","operator":"=="}]
        ],"labels":["0-10","10-20","20-30","30-40","40-50","50-60","60-70","70-80","80-90","90-100"]}}
      }}
      metrics={[{
        config:{},
        filter: [],
        formatFunction: [],
        metric: "driversQuantity",
        name: "driversQuantity",
        reduceFunction: {type: "AVG"},
        type: "AVG"
      }]} 
      config={{
        "tooltip":{"valuesConfig":[
          {"identifier":"x","valueFormat":{"type":"STRING","format":""},"wrapper":`<div>${props.language.indice} <span style='font-weight: bold;'>%v</span></div>`},
          {"identifier":"y","valueFormat":{"type":"NUMBER","format":"d"},"wrapper":`<div><span style='font-weight:bold;'>%v</span> ${props.language.drivers}</div>`}
        ]},
        "horizontal":false,
        "gap":80,
        "colors":[
          utilFunction.getColorCategory(props.graphColorRange,0),
          utilFunction.getColorCategory(props.graphColorRange,10),
          utilFunction.getColorCategory(props.graphColorRange,20),
          utilFunction.getColorCategory(props.graphColorRange,30),
          utilFunction.getColorCategory(props.graphColorRange,40),
          utilFunction.getColorCategory(props.graphColorRange,50),
          utilFunction.getColorCategory(props.graphColorRange,60),
          utilFunction.getColorCategory(props.graphColorRange,70),
          utilFunction.getColorCategory(props.graphColorRange,80),
          utilFunction.getColorCategory(props.graphColorRange,90)
        ],
        "xAxis":{"labelPadding":38,"rotation":0},
        "yAxis":{"show":true,"horizontalLines":false,"ticksNumber":4,"format":"d","autoRange":{"active":true,"max":1,"min":0}}
      }}
      dashboardId={"detail_fatigue"}
    />
  </div>
);
  
export default DriversRiskDistributionGraph;


// WEBPACK FOOTER //
// ./source/client/components/detail_fatigue/driversRiskDristributionGraph.jsx